module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00060.a201e3c1.jpg";